import {
  AndroidOutlined,
  BarChartOutlined,
  ContactsOutlined,
  DashboardOutlined,
  DesktopOutlined,
  // HistoryOutlined,
  SettingOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  UserAddOutlined,
  UsergroupAddOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { getUserData } from "../utils/utils";
import { getReq } from "../utils/constant";
import pinpad from "../assets/pinpad.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPeopleRoof } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
const ROOT_SUBMENU_KEYS = ["sub1", "sub2", "sub3", "sub4", "sub5", "sub6"];
const SIDEBAR_CONFIGS = {
  employee: [
    {
      key: "1",
      icon: <DashboardOutlined />,
      label: <NavLink to="/merchant-dashboard">Dashboard</NavLink>,
    },
    {
      key: "2",
      icon: <UserOutlined />,
      label: <NavLink to="/assigned-customers">Bussiness</NavLink>,
    },
    {
      key: "3",
      icon: <ShoppingCartOutlined />,
      label: <NavLink to="/orders">Sales Order</NavLink>,
    },
    {
      key: "sub4",
      icon: <BarChartOutlined />,
      label: "Reports",
      showIf: (deliveryperson) => !!deliveryperson,
      children: [
        {
          key: "5",
          label: (
            <NavLink to="/report/emp-productivity">Productivity Report</NavLink>
          ),
          showIf: (deliveryperson) => !!deliveryperson,
        },
        {
          key: "6",
          label: (
            <NavLink to="/report/emp-commission">Commission Report</NavLink>
          ),
          showIf: (deliveryperson) => !!deliveryperson,
        },
      ],
    },
  ],
  merchant: [
    {
      key: "13",
      icon: <DashboardOutlined />,
      label: <NavLink to="/merchant-dashboard">Dashboard</NavLink>,
    },
    {
      key: "sub1",
      icon: (
        <FontAwesomeIcon icon={faPeopleRoof} style={{ color: "#ffffff" }} />
      ),
      label: "Sales Management",
      showIf: (vendorNumber, merchantCategory) =>
        !!vendorNumber || merchantCategory === "Wholesale",
      children: [
        {
          key: "14",
          label: <NavLink to="/salesperson-setup">Salesperson</NavLink>,
          showIf: (vendorNumber, merchantCategory) =>
            !!vendorNumber || merchantCategory === "Wholesale",
        },
        {
          key: "15",
          label: <NavLink to="/deliveryperson-setup">Delivery Person</NavLink>,
          showIf: (vendorNumber, merchantCategory) =>
            !!vendorNumber || merchantCategory === "Wholesale",
        },
      ],
    },
    {
      key: "16",
      icon: <ShoppingCartOutlined />,
      label: <NavLink to="/orders">Sales Order</NavLink>,
      showIf: (vendorNumber, merchantCategory) =>
        !!vendorNumber || merchantCategory === "Wholesale",
    },
    {
      key: "sub2",
      icon: <ShopOutlined />,
      label: "Store Management",
      children: [
        {
          key: "17",
          label: (
            <NavLink to="/storemanagement/registeredPos-list">
              Registered POS
            </NavLink>
          ),
        },
        {
          key: "18",
          label: (
            <NavLink to="/storemanagement/pos-customize">
              Customize POS Screen
            </NavLink>
          ),
        },
        {
          key: "19",
          label: (
            <NavLink to="/storemanagement/add-department">Departments</NavLink>
          ),
        },
        {
          key: "20",
          label: <NavLink to="/storemanagement/add-product">Products</NavLink>,
        },
        // {
        //   key: "21",
        //   label: (
        //     <NavLink to="/storemanagement/barcode-scale">Barcode Scale</NavLink>
        //   ),
        // },
        {
          key: "22",
          label: <NavLink to="/storemanagement/add-flag">Flags</NavLink>,
        },
        {
          key: "23",
          label: (
            <NavLink to="/storemanagement/add-promotion">Promotions</NavLink>
          ),
        },
        {
          key: "24",
          label: (
            <NavLink to="/storemanagement/mass-product-update">
              Mass Update
            </NavLink>
          ),
        },
        {
          key: "25",
          label: (
            <NavLink to="/storemanagement/purchase-order">
              Purchase Order
            </NavLink>
          ),
        },
        {
          key: "26",
          label: (
            <NavLink to="/storemanagement/store-setting">Settings</NavLink>
          ),
        },
      ],
    },
    {
      key: "sub3",
      icon: <UsergroupAddOutlined />,
      label: "Employee Management",
      children: [
        {
          key: "27",
          label: (
            <NavLink to="/employeeManagement/add-employee-role">Role</NavLink>
          ),
        },
        {
          key: "28",
          label: (
            <NavLink to="/employeeManagement/add-employee">Employee</NavLink>
          ),
        },
        {
          key: "29",
          label: (
            <NavLink to="/report/productivity">Employee Productivity</NavLink>
          ),
        },
        {
          key: "30",
          label: (
            <NavLink to="/report/emp-commission">Commission Report</NavLink>
          ),
          showIf: (vendorNumber, merchantCategory) =>
            !!vendorNumber || merchantCategory === "Wholesale",
        },
      ],
    },
    {
      key: "sub4",
      icon: <BarChartOutlined />,
      label: "Reports",
      children: [
        {
          key: "31",
          label: <NavLink to="/report/sales-report">Sales Report</NavLink>,
        },
        {
          key: "32",
          label: <NavLink to="/report/shift-report">Shift Report</NavLink>,
        },
        {
          key: "33",
          label: <NavLink to="/report/department">Department Report</NavLink>,
        },
        {
          key: "34",
          label: <NavLink to="/report/product">Product Report</NavLink>,
        },
        {
          key: "35",
          label: <NavLink to="/report/tax-report">Tax Report</NavLink>,
        },
        {
          key: "36",
          label: <NavLink to="/report/pay-roll">Pay Roll Report</NavLink>,
        },
        {
          key: "37",
          label: (
            <NavLink to="/report/clock-in-out">Clock In/Out Report</NavLink>
          ),
        },
        {
          key: "38",
          label: <NavLink to="/report/transaction">Transaction Report</NavLink>,
        },
        {
          key: "39",
          label: <NavLink to="/report/cashdrop">Cash In/Out Report</NavLink>,
        },
        {
          key: "40",
          label: <NavLink to="/report/batch-report">Batch Report</NavLink>,
        },
        {
          key: "41",
          label: <NavLink to="/report/cona-report">CONA Report</NavLink>,
          showIf: (vendorNumber) => !!vendorNumber,
        },
      ],
    },
    {
      key: "42",
      icon: <UserOutlined />,
      label: <NavLink to="/customer-engagement">Customer Engagement</NavLink>,
    },
    {
      key: "43",
      icon: <ContactsOutlined />,
      label: <NavLink to="/contact-us">Contact Us</NavLink>,
    },
  ],
  supervisor: [
    {
      key: "13a",
      icon: <DashboardOutlined />,
      label: <NavLink to="/merchant-dashboard">Dashboard</NavLink>,
    },
    {
      key: "sub1a",
      icon: (
        <FontAwesomeIcon icon={faPeopleRoof} style={{ color: "#ffffff" }} />
      ),
      label: "Sales Management",
      // permissionKey: "isViewSalesperson",
      children: [
        {
          key: "14a",
          label: <NavLink to="/salesperson-setup">Salesperson</NavLink>,
          permissionKey: "isViewSalesperson",
        },
        {
          key: "15a",
          label: <NavLink to="/deliveryperson-setup">Delivery Person</NavLink>,
          permissionKey: "isViewDeliveryperson",
        },
      ],
    },
    {
      key: "16a",
      icon: <ShoppingCartOutlined />,
      label: <NavLink to="/orders">Sales Order</NavLink>,
      permissionKey: "isAllowViewOrder",
    },
    {
      key: "sub2a",
      icon: <ShopOutlined />,
      label: "Store Management",
      children: [
        {
          key: "17a",
          label: (
            <NavLink to="/storemanagement/registeredPos-list">
              Registered POS
            </NavLink>
          ),
          permissionKey: "isViewPOS",
        },
        {
          key: "18a",
          label: (
            <NavLink to="/storemanagement/pos-customize">
              Customize POS Screen
            </NavLink>
          ),
          permissionKey: "isCustomizePOSScreen",
        },
        {
          key: "19a",
          label: (
            <NavLink to="/storemanagement/add-department">Departments</NavLink>
          ),
          permissionKey: "isViewDepartment",
        },
        {
          key: "20a",
          label: <NavLink to="/storemanagement/add-product">Products</NavLink>,
          permissionKey: "isViewItem",
        },
        // {
        //   key: "21a",
        //   label: (
        //     <NavLink to="/storemanagement/barcode-scale">Barcode Scale</NavLink>
        //   ),
        //   permissionKey: "isViewBarcodeScale",
        // },
        {
          key: "22a",
          label: <NavLink to="/storemanagement/add-flag">Flags</NavLink>,
          permissionKey: "isViewFlag",
        },
        {
          key: "23a",
          label: (
            <NavLink to="/storemanagement/add-promotion">Promotions</NavLink>
          ),
          permissionKey: "isViewPromotion",
        },
        {
          key: "24a",
          label: (
            <NavLink to="/storemanagement/mass-product-update">
              Mass Update
            </NavLink>
          ),
          permissionKey: "isViewMassUpdate",
        },
        {
          key: "25a",
          label: (
            <NavLink to="/storemanagement/purchase-order">
              Purchase Order
            </NavLink>
          ),
          permissionKey: "isViewPurchaseOrder",
        },
        {
          key: "26a",
          label: (
            <NavLink to="/storemanagement/store-setting">Settings</NavLink>
          ),
          permissionKey: "isViewSetting",
        },
      ],
    },
    {
      key: "sub3q",
      icon: <UsergroupAddOutlined />,
      label: "Employee Management",
      children: [
        {
          key: "27q",
          label: (
            <NavLink to="/employeeManagement/add-employee-role">Role</NavLink>
          ),
          permissionKey: "isViewEmployeeRole",
        },
        {
          key: "28q",
          label: (
            <NavLink to="/employeeManagement/add-employee">Employee</NavLink>
          ),
          permissionKey: "isViewEmployee",
        },
        {
          key: "29q",
          label: (
            <NavLink to="/report/productivity">Employee Productivity</NavLink>
          ),
          permissionKey: "isViewProductivityReport",
        },
        {
          key: "30q",
          label: (
            <NavLink to="/report/emp-commission">Commission Report</NavLink>
          ),
          // permissionKey: true,
        },
      ],
    },
    {
      key: "sub4q",
      icon: <BarChartOutlined />,
      label: "Reports",
      children: [
        {
          key: "31q",
          label: <NavLink to="/report/sales-report">Sales Report</NavLink>,
          permissionKey: "isViewSalesReport",
        },

        {
          key: "32q",
          label: <NavLink to="/report/shift-report">Shift Report</NavLink>,
          permissionKey: "isViewShiftReport",
        },
        {
          key: "33q",
          label: <NavLink to="/report/department">Department Report</NavLink>,
          permissionKey: "isViewDepartmentReport",
        },
        {
          key: "34q",
          label: <NavLink to="/report/product">Product Report</NavLink>,
          permissionKey: "isViewProductReport",
        },
        {
          key: "35q",
          label: <NavLink to="/report/tax-report">Tax Report</NavLink>,
          permissionKey: "isViewTaxReport",
        },
        {
          key: "36q",
          label: <NavLink to="/report/pay-roll">Pay Roll Report</NavLink>,
          permissionKey: "isViewPayrollReport",
        },
        {
          key: "37q",
          label: (
            <NavLink to="/report/clock-in-out">Clock In/Out Report</NavLink>
          ),
          permissionKey: "isViewClockInClockOutReport",
        },
        {
          key: "38q",
          label: <NavLink to="/report/transaction">Transaction Report</NavLink>,
          permissionKey: "isViewTransactionReport",
        },
        {
          key: "39q",
          label: <NavLink to="/report/cashdrop">Cash In/Out Report</NavLink>,
          permissionKey: true,
        },
        {
          key: "40q",
          label: <NavLink to="/report/batch-report">Batch Report</NavLink>,
          permissionKey: "isViewBatchReport",
        },
      ],
    },
    {
      key: "41q",
      icon: <UserOutlined />,
      label: <NavLink to="/customer-engagement">Customer Engagement</NavLink>,
      permissionKey: "isViewCustomerTab",
    },
    {
      key: "42q",
      icon: <ContactsOutlined />,
      label: <NavLink to="/contact-us">Contact Us</NavLink>,
      // permissionKey: true,
    },
  ],
  superAdmin: [
    {
      key: "45",
      icon: <DashboardOutlined />,
      label: <NavLink to="/dashboard">Dashboard</NavLink>,
    },
    {
      key: "46",
      icon: <UserOutlined />,
      label: <NavLink to="/manage-agent">Agents</NavLink>,
    },
    {
      key: "47",
      icon: <UserAddOutlined />,
      NavLink: "/manage-merchant",
      label: <NavLink to="/manage-merchant">Merchants</NavLink>,
    },
    {
      key: "48",
      icon: <ShopOutlined />,
      NavLink: "/add-store",
      label: <NavLink to="/add-store">Stores</NavLink>,
    },
    {
      key: "49",
      icon: <DesktopOutlined />,
      NavLink: "/add-pos",
      label: <NavLink to="/add-pos">POS</NavLink>,
    },

    {
      key: "50",
      icon: <img src={pinpad} alt="pinpad" className="pinpad-icons" />,
      NavLink: "/all-pinpad-list",
      label: <NavLink to="/all-pinpad-list">Pinpad Terminals</NavLink>,
    },

    {
      key: "51",
      icon: <AndroidOutlined />,
      NavLink: "/upload-pos-apk",
      label: <NavLink to="/upload-pos-apk">APK Releases</NavLink>,
    },
    {
      key: "52",
      icon: <SettingOutlined />,
      NavLink: "/user-management",
      label: <NavLink to="/user-management">User Management</NavLink>,
    },
  ],
  agent: [
    {
      key: "53",
      icon: <DashboardOutlined />,
      label: <NavLink to="/agent-dashboard">Dashboard</NavLink>,
    },
    {
      key: "54",
      icon: <UserOutlined />,
      label: <NavLink to="/manage-merchant">Merchants</NavLink>,
    },
    {
      key: "55",
      icon: <ShopOutlined />,
      label: <NavLink to="/add-store">Stores</NavLink>,
    },
    {
      key: "56",
      icon: <DesktopOutlined />,
      label: <NavLink to="/add-pos">POS</NavLink>,
    },
  ],
  admin: [
    {
      key: "57",
      icon: <DashboardOutlined />,
      label: <NavLink to="/dashboard">Dashboard</NavLink>,
    },
    {
      key: "58",
      icon: <UserOutlined />,
      label: <NavLink to="/manage-agent">Agents</NavLink>,
      showIf: (userPermissions) => userPermissions?.isAllowViewAgent,
    },
    {
      key: "59",
      icon: <UserAddOutlined />,
      NavLink: "/manage-merchant",
      label: <NavLink to="/manage-merchant">Merchants</NavLink>,
      showIf: (userPermissions) => userPermissions?.isAllowViewMerchant,
    },
    {
      key: "60",
      icon: <ShopOutlined />,
      NavLink: "/add-store",
      label: <NavLink to="/add-store">Stores</NavLink>,
      showIf: (userPermissions) => userPermissions?.isAllowViewStore,
    },
    {
      key: "61",
      icon: <DesktopOutlined />,
      NavLink: "/add-pos",
      label: <NavLink to="/add-pos">POS</NavLink>,
      showIf: (userPermissions) => userPermissions?.isAllowViewStore,
    },
  ],
};

const RoleWiseSidebar = ({ role }) => {
  const [openKeys, setOpenKeys] = useState([]);
  const [sidebar, setSidebar] = useState([]);
  const [vendorNumber, setVendorNumber] = useState(null);
  const [deliveryperson, setDeliveryperson] = useState(null);
  const [userPermissions, setUserPermissions] = useState({});
  const navigate = useNavigate();
  const userData = useSelector((store) => store.userReducer.userData);
  useEffect(() => {
    if (userData?.empRole === "Sales Person") {
      setDeliveryperson(userData?.empRole);
    } else {
      setDeliveryperson(null);
    }
    const keys = localStorage.getItem("openKeys");
    if (keys) {
      setOpenKeys([keys]);
    }
    const localData = JSON.parse(getUserData());
    setVendorNumber(localData?.vendorNumber || null);
    setUserPermissions(localData?.permissions || {});
    if (role === "admin") {
      getAdminPermissions();
    }
    // eslint-disable-next-line
  }, [role, userData?.empRole]);

  useEffect(() => {
    switch (role || userData?.empRole) {
      case "super-admin":
        setSidebar(SIDEBAR_CONFIGS.superAdmin);
        break;
      case "admin":
        setSidebar(filterSubAdminSidebar(userPermissions));
        break;
      case "agent":
        setSidebar(SIDEBAR_CONFIGS.agent);
        break;
      case "merchant":
        setSidebar(getMerchantSidebar(vendorNumber));
        break;
      case "super-merchant":
        setSidebar(getMerchantSidebar(vendorNumber));
        break;
      case "supervisor":
        setSidebar(getSupervisorSidebar(userPermissions));
        break;
      case "employee":
        setSidebar(getEmployeeSidebar(deliveryperson));
        break;
      default:
        return console.warn("Role not found");
    }
    // eslint-disable-next-line
  }, [role, vendorNumber, userPermissions, userData?.empRole]);
  useEffect(() => {
    const currentRole = role || userData?.empRole;
    switch (true) {
      case currentRole === "super-admin":
        setSidebar(SIDEBAR_CONFIGS.superAdmin);
        break;
      case currentRole === "admin":
        setSidebar(filterSubAdminSidebar(userPermissions));
        break;
      // Specific logic for Employee Sub-roles
      case currentRole === "employee" && userData?.empRole === "Supervisor":
        setSidebar(getSupervisorSidebar(userPermissions));
        // setSidebar(getMerchantSidebar(vendorNumber));
        break;
      case (currentRole === "employee" &&
        userData?.empRole === "Sales Person") ||
        userData?.empRole === "Delivery Person":
        setSidebar(getEmployeeSidebar(deliveryperson));
        break;
      case currentRole === "agent":
        setSidebar(SIDEBAR_CONFIGS.agent);
        break;
      case ["merchant", "super-merchant"].includes(currentRole):
        setSidebar(getMerchantSidebar(vendorNumber));
        break;
      default:
        console.warn("Role not found");
    }
    // eslint-disable-next-line
  }, [role, vendorNumber, userPermissions, userData?.empRole, deliveryperson]);

  const getAdminPermissions = async () => {
    const localData = JSON.parse(getUserData());
    const { _id } = localData;
    const response = await getReq(
      `web/adminPermissions?adminId=${_id}`,
      navigate,
    );
    const { result } = response.data;
    setUserPermissions(result[0]?.permissions || {});
  };

  const filterSubAdminSidebar = (userPermissions) => {
    return SIDEBAR_CONFIGS?.admin?.filter((item) => {
      if (!item.showIf) {
        return true;
      }
      return item.showIf(userPermissions);
    });
  };
  const getSupervisorSidebar = (userPermissions) => {
    // Define the map of permissionKeys to actual boolean flags in your userPermissions
    const permissionMap = {
      isViewSetting: userPermissions?.isViewSetting,
      isViewMassUpdate: userPermissions?.isViewMassUpdate,
      isViewPurchaseOrder: userPermissions?.isViewPurchaseOrder,
      isViewFlag: userPermissions?.isViewFlag,
      isAllowSaleOrder: userPermissions?.isAllowSaleOrder,
      isAllowViewOrderHistory: userPermissions?.isAllowViewOrderHistory,
      isAllowAssignOrder: userPermissions?.isAllowAssignOrder,
      isAllowUpdateOrder: userPermissions?.isAllowUpdateOrder,
      isAllowViewOrder: userPermissions?.isAllowViewOrder,
      isViewSalesperson: userPermissions?.isViewSalesperson,
      isUpdateSalesperson: userPermissions?.isUpdateSalesperson,
      isDeleteSalesperson: userPermissions?.isDeleteSalesperson,
      isConfigSalesperson: userPermissions?.isConfigSalesperson,
      isAllowAssignBussiness: userPermissions?.isAllowAssignBussiness,
      isAllowPasswordReset: userPermissions?.isAllowPasswordReset,
      isViewDeliveryperson: userPermissions?.isViewDeliveryperson,
      isUpdateDeliveryperson: userPermissions?.isUpdateDeliveryperson,
      isDeleteDeliveryperson: userPermissions?.isDeleteDeliveryperson,
      isViewPOS: userPermissions?.isViewPOS,
      isCustomizePOSScreen: userPermissions?.isCustomizePOSScreen,
      isAllowPasswordResetDelivery:
        userPermissions?.isAllowPasswordResetDelivery,
      isAllowSale: userPermissions?.isAllowSale,
      isOverriddenPrice: false,
      isViewCustomerTab: userPermissions?.isViewCustomerTab,
      isAllowCashDrop: false,
      isPrintBasket: false,
      isCheckPrice: false,
      isAllowCalculator: false,
      isPrintReceipt: false,
      isAllowRefund: false,
      isAddDiscount: false,
      isAddCoupon: false,
      isViewCustomers: false,
      isRemoveTax: false,
      isRemoveCreditCardFees: false,
      isAllowAddCustomerMobileNumber: false,
      isViewStock: userPermissions?.isViewStock,
      isViewCostPrice: userPermissions?.isViewCostPrice,
      isViewItem: userPermissions?.isViewItem,
      isEditItem: userPermissions?.isEditItem,
      isAddItem: userPermissions?.isAddItem,
      isDeleteItem: userPermissions?.isDeleteItem,
      isViewDepartment: userPermissions?.isViewDepartment,
      isAddDepartment: userPermissions?.isAddDepartment,
      isEditDepartment: userPermissions?.isEditDepartment,
      isDeleteDepartment: userPermissions?.isDeleteDepartment,
      isViewInStoreItem: userPermissions?.isViewInStoreItem,
      isAddInStoreItem: userPermissions?.isAddInStoreItem,
      isEditInStoreItem: userPermissions?.isEditInStoreItem,
      isDeleteInStoreItem: userPermissions?.isDeleteInStoreItem,
      isViewTransaction: userPermissions?.isViewTransaction,
      isViewAllEmpTransaction: userPermissions?.isViewAllEmpTransaction,
      isCreatePromotion: userPermissions?.isCreatePromotion,
      isViewPromotion: userPermissions?.isViewPromotion,
      isViewEmployee: userPermissions?.isViewEmployee,
      isAddEmployee: userPermissions?.isAddEmployee,
      isDeleteEmployee: userPermissions?.isDeleteEmployee,
      isEditEmployee: userPermissions?.isEditEmployee,
      isAddTask: userPermissions?.isAddTask,
      isEditTask: userPermissions?.isEditTask,
      isDeleteTask: userPermissions?.isDeleteTask,
      isViewProductivityReport: userPermissions?.isViewProductivityReport,
      isViewSelfProductivityReport:
        userPermissions?.isViewSelfProductivityReport,
      isViewSalesReport: userPermissions?.isViewSalesReport,
      isViewShiftReport: userPermissions?.isViewShiftReport,
      isViewDepartmentReport: userPermissions?.isViewDepartmentReport,
      isViewProductReport: userPermissions?.isViewProductReport,
      isViewTaxReport: userPermissions?.isViewTaxReport,
      isViewPayrollReport: userPermissions?.isViewPayrollReport,
      isViewClockInClockOutReport: userPermissions?.isViewClockInClockOutReport,
      isViewTransactionReport: userPermissions?.isViewTransactionReport,
      isViewBatchReport: userPermissions?.isViewBatchReport,
    };
    const filterMenu = (menuList) => {
      return (
        menuList
          .filter((item) => {
            // 1. If no permissionKey is required, show the item
            if (!item.permissionKey) return true;

            // 2. Check if the specific permissionKey is true in our map
            // This handles cases like 'isViewDepartments' or your new module keys
            return permissionMap[item.permissionKey] === true;
          })
          .map((item) => {
            // 3. If item has children, recursively filter them
            if (item.children) {
              return {
                ...item,
                children: filterMenu(item.children),
              };
            }
            return item;
          })
          // 4. Clean up: don't show parent menus if all their children were filtered out
          .filter((item) => !item.children || item.children.length > 0)
      );
    };
    return filterMenu(SIDEBAR_CONFIGS?.supervisor || []);
  };
  // const getSupervisorSidebar = (userPermissions) => {
  //   return SIDEBAR_CONFIGS?.supervisor?.filter((item) => {
  //     if (!item.showIf) {
  //       return true;
  //     }
  //     return item.showIf(userPermissions);
  //   });
  // };

  const getEmployeeSidebar = (deliveryperson) => {
    return SIDEBAR_CONFIGS.employee
      ?.filter((child) => {
        if (child.showIf) {
          return child.showIf(deliveryperson);
        }
        return true;
      })
      ?.map((item) => {
        if (item.children) {
          return {
            ...item,
            children: item.children?.filter((child) => {
              if (child.showIf) {
                return child.showIf(deliveryperson);
              }
              return true;
            }),
          };
        }
        return item;
      });
  };
  const getMerchantSidebar = (vendorNumber) => {
    const category = userData?.merchantCategory;
    return SIDEBAR_CONFIGS.merchant
      ?.filter((child) => {
        if (child.showIf) {
          return child.showIf(vendorNumber, category);
        }
        return true;
      })
      ?.map((item) => {
        if (item.children) {
          return {
            ...item,
            children: item.children?.filter((child) => {
              if (child.showIf) {
                return child.showIf(vendorNumber, category);
              }
              return true;
            }),
          };
        }
        return item;
      });
  };
  const onOpenChange = (keys) => {
    localStorage.setItem("openKeys", keys[keys.length - 1]);
    const latestOpenKey = keys?.find((key) => openKeys.indexOf(key) === -1);
    if (ROOT_SUBMENU_KEYS.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  return (
    <Menu
      theme="dark"
      mode="inline"
      defaultSelectedKeys={window.location.pathname}
      defaultOpenKeys={openKeys}
      items={sidebar}
      openKeys={openKeys}
      onOpenChange={onOpenChange}
    />
  );
};

export default RoleWiseSidebar;
